import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import {
  PageSettingsModel, FilterSettingsModel, SortSettingsModel,
  EditSettingsModel, CommandModel, GridComponent, Column, IEditCell, ActionEventArgs, ColumnModel, IFilter, Filter
} from '@syncfusion/ej2-angular-grids';
import { Query, DataManager } from '@syncfusion/ej2-data';
import { ApplicationState, EngDrawReport, getApplicationState, GetCAD, GetOutstandingED, OutstandingED, State, UpdateEngDraw } from 'src/app/state-management';
import { DropDownList } from '@syncfusion/ej2-angular-dropdowns';
import { ClickEventArgs } from '@syncfusion/ej2-angular-navigations';


@Component({
    selector: 'app-dnv-ed-reports',
    templateUrl: './dnv-ed-reports.component.html',
    styleUrls: ['./dnv-ed-reports.component.scss'],
    standalone: false
})
export class DnvEDReportsComponent implements OnInit {

  @ViewChild('grid') public grid: GridComponent;
  @ViewChild('grid2') public grid2: GridComponent;

  application$: Observable<ApplicationState>;
  applicationState: ApplicationState;

  private ngUnsubscribe: Subject<void> = new Subject();

  headerHeight = 54;
  pageSettings: PageSettingsModel;
  editSettings: EditSettingsModel;
  commands: CommandModel[];
  cadParams: IEditCell;
  edParams: IEditCell;
  panelHeight: number;
  cad: EngDrawReport[] = [];
  outstandingED: OutstandingED[] = [];
  deliveryLeadParams: IEditCell;

  grid2Status = [
    { status: 'Complete' },
    { status: 'Incomplete' }
  ];

  gridStatus = [
    { status: '' },
    { status: 'Cancelled' },
    { status: 'Construction Complete' },
    { status: 'Dev Eng Hold' },
    { status: 'Issued for Construction' },
    { status: 'Issued for Review' },
    { status: 'Lost' },
    { status: 'On Hold' }
  ];

  filterOption: FilterSettingsModel = { type: 'Menu' };
  showGridClear = false;
  showGrid2Clear = false;
  dateFormat: string;
  filter: Object;
  statusFilter: IFilter;
  public dropInstance?: DropDownList;
  gridDeliveryLead = [
    { deliveryLead: '' },
    { deliveryLead: 'Construction' },
    { deliveryLead: 'Development Engineering' },
    { deliveryLead: 'Engineering Planning and Design' },
    { deliveryLead: 'Facilities' },
    { deliveryLead: 'Parks' },
    { deliveryLead: 'Project Delivery Office' },
    { deliveryLead: 'Transportation' },
    { deliveryLead: 'Utilities' }
  ];

  constructor(
    private store: Store<State>,
  ) {
    this.application$ = this.store.select(getApplicationState);
  }

  ngOnInit(): void {
    this.store.dispatch(new GetCAD());
    this.store.dispatch(new GetOutstandingED());

    this.application$.pipe(
      takeUntil(this.ngUnsubscribe)
    ).subscribe((state: ApplicationState) => {
      this.applicationState = state;
      this.cad = state.cad?.map((c: EngDrawReport) => Object.assign({}, c, {
        projectStartDate: new Date(c.projectStartDate),
        projectStatus: c.projectStatus ? c.projectStatus : '',
        capProjId: c.capProjId ? c.capProjId : '',
        comments: c.comments ? c.comments : ''
      }))
      this.outstandingED = state.outstandingED?.map((o: OutstandingED) => Object.assign({}, o, {
        projectStartDate: new Date(o.projectStartDate)
      }))
    });

    this.pageSettings = {
      pageSize: 10
    };

    this.editSettings = { allowEditing: true };
    this.commands = [{ type: 'Edit', buttonOption: { cssClass: 'e-flat', iconCss: 'e-edit e-icons' } },
    { type: 'Save', buttonOption: { cssClass: 'e-flat', iconCss: 'e-update e-icons' } },
    { type: 'Cancel', buttonOption: { cssClass: 'e-flat', iconCss: 'e-cancel-icon e-icons' } }];

    this.edParams = {
      params: {
        allowFiltering: true,
        dataSource: new DataManager(this.grid2Status),
        fields: { text: 'status', value: 'status' },
        query: new Query(),
        actionComplete: () => false
      }
    };

    this.cadParams = {
      params: {
        allowFiltering: true,
        dataSource: new DataManager(this.gridStatus),
        fields: { text: 'status', value: 'status' },
        query: new Query(),
        actionComplete: () => false,
        popupWidth: 250
      }
    };

    this.deliveryLeadParams = {
      params: {
        allowFiltering: true,
        dataSource: new DataManager(this.gridDeliveryLead),
        fields: { text: 'deliveryLead', value: 'deliveryLead' },
        query: new Query(),
        actionComplete: () => false,
        popupWidth: 280
      }
    };

    this.panelHeight = this.applicationState.windowInnerHeight - this.headerHeight - 40;

    this.dateFormat = 'yyyy-MM-dd';
    this.filter = { params: { format: this.dateFormat } };

    // this.statusFilter = {
    //   ui: {
    //     create: (args: { target: Element, column: object }) => {
    //       const flValInput: HTMLElement = createElement('input', { className: 'flm-input' });
    //       (args as any).target.appendChild(flValInput);
    //       this.dropInstance = new DropDownList({
    //         dataSource: new DataManager(this.gridStatus),
    //         fields: { text: 'status', value: 'status' },
    //         placeholder: 'Select a value',
    //         popupHeight: '200px'
    //       });
    //       this.dropInstance.appendTo(flValInput);
    //     },
    //     write: (args: {
    //       column: object, target: Element, parent: any,
    //       filteredValue: number | string
    //     }) => {
    //       this.dropInstance.value = (args as any).filteredValue;
    //     },
    //     read: (args: { target: Element, column: any, operator: string, fltrObj: Filter }) => {
    //       (args as any).fltrObj.filterByColumn((args as any).column.field, (args as any).operator, this.dropInstance?.value);

    //     }
    //   }
    // };
  }

  dataBound(): void {
    // this.grid.autoFitColumns();
    // this.grid2.autoFitColumns();
  }

  loadCAD(): void {
    for (const c of this.grid.columns) {
      if ((c as Column).field !== 'comments' && (c as Column).field !== 'projectStatus' && (c as Column).field !== 'capProjId' && (c as Column).field !== 'deliveryLead') {
        (c as Column).allowEditing = false;
      }
    }
  }

  loadOutstanding(): void {
    for (const c of this.grid2.columns) {
      if ((c as Column).field !== 'status' && (c as Column).field !== 'comments') {
        (c as Column).allowEditing = false;
      }
    }
  }

  toolbarClick(args: ClickEventArgs): void {
    if (args.item.id === 'Grid_excelexport') { // 'Grid_excelexport' -> Grid component id + _ + toolbar item name
      this.grid.excelExport({
        fileName: 'CAD_Export.xlsx'
      });
    } else if (args.item.id === 'Grid2_excelexport') {
      this.grid2.excelExport({
        fileName: 'Outstanding_EngDraw_Export.xlsx'
      });
    }
  }

  onActionBeginCAD(args: ActionEventArgs): void {
    if (args.action && args.action === 'edit') {
      // alert(JSON.stringify(args.data));
      this.store.dispatch(new UpdateEngDraw({ data: args.data, type: 'cad' }));
    }
  }

  onActionBeginOutstanding(args: ActionEventArgs): void {
    if (args.action && args.action === 'edit') {
      // alert(JSON.stringify(args.data));
      this.store.dispatch(new UpdateEngDraw({ data: { currentData: args.data, prevData: args.previousData }, type: 'outstanding' }));
    }
  }

  onClearCadSearch(): void {
    this.grid.searchSettings.key = '';
    (document.getElementById(this.grid.element.id + '_searchbar') as HTMLInputElement).value = '';
    this.showGridClear = false;
  }

  onClearOutSearch(): void {
    this.grid2.searchSettings.key = '';
    (document.getElementById(this.grid2.element.id + '_searchbar') as HTMLInputElement).value = '';
    this.showGrid2Clear = false;
  }

  onCADCreated(): void {
    // cad applications
    document.getElementById(this.grid.element.id + '_searchbar').addEventListener('keyup', () => {
      if ((event.target as HTMLInputElement).value.length > 0) {
        this.showGridClear = true;
      }
    });
  }

  onOutCreated(): void {
    // outstanding drawings
    document.getElementById(this.grid2.element.id + '_searchbar').addEventListener('keyup', () => {
      if ((event.target as HTMLInputElement).value.length > 0) {
        this.showGrid2Clear = true;
      }
    });
  }

}
